import { LOGIN_SUCCESS } from "../LogIn/action";
import { SIGN_OUT_USER } from "../RegistrationForm/action";

function userReducer(state = null, action) {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return action.payload;

    case SIGN_OUT_USER:
      return null;

    default:
      return state;
  }
}

export default userReducer;
